export default [
  {
    path: '/admin/move-loan-write-offs',
    name: 'move-loan-write-off',
    meta: { requiresAuth: true },
    component: () => import('@/pages/credit-operation/move-loan-write-off')
  }
]
